<div class="ref-container" (click)="this.toggle()">
  <div class="rect" [ngClass]="this.getClasses()"></div>
  <div class="space-between align-center">
    @if (this.haveChildren) {
      @if (!this.isExpanded) {
        <cam-font-icon name="arrow-big-right" type="lg"></cam-font-icon>
      } @else {
        <cam-font-icon name="arrow-big-bottom" type="lg"></cam-font-icon>
      }
    }
    <div [class.space]="!this.haveChildren">
      {{ this.value }}
    </div>
  </div>
</div>
